import { SettingsManager as BaseSettingsManager } from '@bn-games/settings-core';
import { DEFAULT_SETTINGS, type Settings } from './types.js';

const STORAGE_KEY = 'sudoku-settings';

function merge(stored: Record<string, unknown>, defaults: Settings): Settings {
  return {
    difficulty:
      stored['difficulty'] === 'easy' ||
      stored['difficulty'] === 'medium' ||
      stored['difficulty'] === 'hard'
        ? stored['difficulty']
        : defaults.difficulty,
    highlightErrors:
      typeof stored['highlightErrors'] === 'boolean'
        ? stored['highlightErrors']
        : defaults.highlightErrors,
    theme:
      stored['theme'] === 'mahogany' ||
      stored['theme'] === 'persian' ||
      stored['theme'] === 'deco' ||
      stored['theme'] === 'monte'
        ? stored['theme']
        : defaults.theme,
    language:
      stored['language'] === 'en' || stored['language'] === 'ru'
        ? stored['language']
        : defaults.language,
  };
}

export class SettingsManager extends BaseSettingsManager<Settings> {
  constructor() {
    super(STORAGE_KEY, DEFAULT_SETTINGS, merge);
  }
}
